import React, {useEffect, useState} from 'react'
import Color from '../../Components/Colors/Color'
import ClipLoader from 'react-spinners/ClipLoader'
import CustomSnackbar from '../Components/Snackbar/Snackbar'
import '../Styles/AdminAnnouncement.css'
import '../Components/Overlay/Overlay.css'
import { useNavigate } from 'react-router-dom'
import { fetchAnnouncement } from '../Controller/AnnouncementController'

const AdminAnnouncement = () => {

    const navigate = useNavigate();

    const [announcements, setAnnouncements] = useState([]);

    const [loading, setLoading] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [finishFlag, setFinishFlag] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);


    useEffect(() => {
        
        const handleFetchAnnouncements = async () => {
            try{
                setLoading(true);
                const response = await fetchAnnouncement();
                const announcementList = response.data.announcements;
                console.log(announcementList);
                const sortedAnnouncemnets = announcementList.sort((a, b) => new Date(a.endDate) - new Date(b.endDate));
                setAnnouncements(sortedAnnouncemnets || [])
    
            }catch(error)  {
                    setMessageSnackbar(error?.response?.data?.message || "An error occurred")
                    setSeveritySnackbar("error");
                    setOpenSnackbar(true);
            }finally{
                setLoading(false);
            }
        }
        
        handleFetchAnnouncements();
    },[])

    const getCurrentDate = () => {
        const currentDate = new Date();
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        return currentDate.toLocaleDateString('en-CA', options);
    };

    const formatDate = (dateString) => {
        if(!dateString) return getCurrentDate();
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        return date.toLocaleDateString('en-CA', options);
    }

    const moveToDetail = (announcement) => {
        navigate(`./details?id=${announcement.id}`)
    }

    const moveToNewAnnouncement = () => {
        navigate('./new-announcement')
    }



    return(
        <>
            <div className='admin-announcement-container' style={{backgroundColor: Color.secondaryText, color: Color.thirdText}}>
                <div className='admin-announcement-header-container'>
                    <h4 className='admin-announcement-header'>
                        Announcements
                    </h4>
                    <div className='admin-announcement-add-btn-container'>
                            <span className='admin-announcement-add-btn fa-solid fa-plus' onClick={moveToNewAnnouncement}></span>
                    </div>
                </div>
                <div className='admin-announcements-contents-container'>
                    <div className='admin-announcement-contents'>
                        {announcements.map((announcement) => {
                            return(
                                <>
                                    {!loading && 
                                    <div className='admin-announcement-card' key={announcement.id} onClick={() => moveToDetail(announcement)}>
                                        <h5 className='admin-announcement-card-title'>
                                            {announcement.title}
                                        </h5> 
                                        <p className='admin-announcement-card-description'>
                                            {announcement.description}
                                        </p>
                                        <h6 className='admin-announcement-card-date'>
                                            {formatDate(announcement.endDate)}
                                        </h6>
                                    </div>
                                    }
                                    
                                </>
                                )
                                })
                        }
                        <div className={`loading-container-overlay-small ${loading ? "" : "stop"}`}>
                            <ClipLoader size={100} color='black' />
                        </div>
                    </div>
                </div>
            </div>

            <CustomSnackbar
            severity={severitySnackbar}
            message={messageSnackbar}
            open={openSnackbar}
            onClose={() => setOpenSnackbar(false)}
            time= {snackbarDuration}
            />
        </>
    )
}

export default AdminAnnouncement;